export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11848.56dcb25e.jpg";